<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>

<app-app-hero></app-app-hero>
<section
    class="tw-max-w-[1380px] tw-px-[28px] tw-py-[40px] md:tw-px-[80px] md:tw-py-[50px]"
>
    <h2
        class="!tw-font-bold !tw-text-[#0F3172] !tw-text-[24px] sm:!tw-text-[30px]"
    >
        {{ 'AWARDS.OVERVIEW.TITLE' | translate }}
    </h2>
    <span class="!tw-text-[14px] sm:!tw-text-[16px]">
        {{ 'AWARDS.OVERVIEW.BODY' | translate }}
    </span>
</section>
<app-awards></app-awards>

<app-footer [selectedLanguage]="selectedLanguage"></app-footer>
